import React from 'react';
import { useLocation } from 'react-router-dom'; 
import phone from '../../assets/images/phone.png';
import phoneBlack from '../../assets/images/phoneBlack.svg';
import './callbutton.css';

const CallButton = ({ number }) => {
  const location = useLocation();

  // დავადგინოთ რომელი სურათი უნდა გამოვიტანოთ
  const isProductPage = location.pathname === '/Product';
  const isWineryProductsPage = location.pathname === '/WineryProducts';
  const isPartnersPage = location.pathname === '/Partners';

  // phoneBlack გამოჩნდება მხოლოდ ამ სამი გვერდის შემთხვევაში
  const phoneIcon = (isProductPage || isWineryProductsPage || isPartnersPage) ? phoneBlack : phone;

  return (
    <div className="call-button navlink">
      <img src={phoneIcon} alt="Phone" />
      <a href={`tel:${number}`}> 
        (+995) 591 09 09 97
      </a>
    </div>
  );
};

export default CallButton;

